// extracted by mini-css-extract-plugin
module.exports = {"sentence":"Sentence_sentence__SNp6a"};